import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createHashRouter, RouterProvider  } from 'react-router-dom';
import LandingPage from './content/landingPage';
import AdvancedPage from './content/advancedPage'
import AuthorizationPage from './content/authorizationPage'
import IdentityPage from './content/identityPage'
import LoggingPage from './content/loggingPage'
import PoliciesPage from './content/policiesPage'
import Resource_serversPage from './content/resource_serversPage'
import SecretsPage from './content/secretsPage'
import ServerPage from './content/serverPage'
import ServicesPage from './content/servicesPage'
import VersionPage from './content/versionPage'



const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <LandingPage />
      },
      { path: "/advanced", element: <AdvancedPage /> },
            { path: "/authorization", element: <AuthorizationPage /> },
            { path: "/identity", element: <IdentityPage /> },
            { path: "/logging", element: <LoggingPage /> },
            { path: "/policies", element: <PoliciesPage /> },
            { path: "/resource_servers", element: <Resource_serversPage /> },
            { path: "/secrets", element: <SecretsPage /> },
            { path: "/server", element: <ServerPage /> },
            { path: "/services", element: <ServicesPage /> },
            { path: "/version", element: <VersionPage /> },

    ]
  },
])

ReactDOM.render(
    <RouterProvider router={router} />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

